import React, { useEffect, useState } from 'react';
import { useScenario } from '../context/ScenarioContext';
import { SectionHeader } from '../components/UI';
import { api } from '../lib/api';
import { Printer } from 'lucide-react';

export default function StoryMode() {
  const { active } = useScenario();
  const [story, setStory] = useState(null);

  useEffect(() => {
    if (!active) return;
    api.get(`/scenarios/${active.id}/story`).then((r) => setStory(r.data));
  }, [active]);

  if (!story) return <div className="label-editorial">Writing the story…</div>;

  return (
    <div className="max-w-3xl">
      <SectionHeader
        eyebrow={`Story · ${story.scenario.name}`}
        title="The business, in plain English"
        description="Short chapters, bound to live numbers. Share this with your advisor, your accountant, or the bank."
        right={
          <button onClick={() => window.print()} className="flex items-center gap-2 border-2 border-indie-navy text-indie-navy px-4 py-2 hover:bg-indie-navy hover:text-indie-cream">
            <Printer size={15} /> Print / PDF
          </button>
        }
      />

      <article data-testid="story-article" className="prose prose-lg max-w-none space-y-10">
        {story.chapters.map((c, i) => (
          <section key={c.title}>
            <div className="label-editorial text-indie-cobalt">Chapter {String(i + 1).padStart(2, '0')}</div>
            <h2 className="text-3xl font-semibold text-indie-navy tracking-tight mt-1">{c.title}</h2>
            <div className="w-16 h-[3px] bg-indie-evergreen mt-3 mb-5" />
            <p className="text-lg leading-[1.75] text-indie-ink/90">{c.body}</p>
          </section>
        ))}
      </article>
    </div>
  );
}
